import React from 'react';
import './ContactSection.css';

function ContactSection() {
  const whatsappNumber = '5532984835922';
  const whatsappMessage = encodeURIComponent('Olá! Tenho uma pergunta sobre seus serviços e gostaria de conversar.');
  const instagramLink = 'https://www.instagram.com/bertolinsolucoes'; // Substitua pelo seu usuário do Instagram

  return (
    <section id="contato" className="contact-section">
      <h2>Entre em Contato</h2>
      <p>Pronto para transformar suas ideias em realidade? Fale conosco! Estamos à disposição para tirar suas dúvidas e iniciar seu projeto.</p>
      <div className="contact-links"> {/* NOVO: Container para os links de contato */}
        <a
          href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button fade-in"
          style={{ animationDelay: '0.8s' }}
        >
          <i className="fab fa-whatsapp footer-social-icon"></i> 
          <span className="whatsapp-button-text">
          WhatsApp: <br/>
            (32) 98483-5922
          </span>
        </a>
        {/* NOVO: Botão/Link para o Instagram */}
        <a
          href={instagramLink}
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-button fade-in"
          style={{ animationDelay: '0.8s' }} // Atraso para animação
        >
          <i className="fab fa-instagram instagram-icon"></i>
          <span className="instagram-button-text">
            Instagram: <br/>
            bertolinsolucoes</span>
        </a>
      </div>
      {/* Formulário de contato comentado como antes */}
    </section>
  );
}

export default ContactSection;